/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class SecurityMergeGrid extends SiteEntityGrid<SecurityMergeRow, any> {
        protected getColumnsKey() { return 'Data.SecurityMerge'; }
        protected getDialogType() { return SecurityMergeDialog; }
        protected getIdProperty() { return SecurityMergeRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityMergeRow.localTextPrefix; }
        protected getService() { return SecurityMergeService.baseUrl; }

        protected unmatched: JQuery;
        protected stale: JQuery;
        protected pendingReview: JQuery;
        private rowSelection: Serenity.GridRowSelectionMixin;


        constructor(container: JQuery) {
            super(container);

            this.element.find('.slick-viewport-top.slick-viewport-left').on('wheel', (event) => {
                event.preventDefault();
                if (!event || !event.originalEvent)
                    return;
                var ev = event.originalEvent;
                var direction = (ev['detail'] < 0 || ev['wheelDelta'] > 0) ? 1 : -1;
                var vp = this.element.find('.slick-viewport-top.slick-viewport-right');
                vp.scrollTop(Math.max(0,
                    vp.scrollTop() + (-direction * 2 * 27)));
            });
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();

            var cbxStyle = "position: relative; top: 2px";
            var preview = $(`<span class="tool-group-like" style="float: left">
<i class="fa fa-binoculars text-blue" style="font-size: 15px"></i> <span style="font-weight: normal">Preview Changes:</span> 
<input type="checkbox" class="preview-inbox" style="${cbxStyle}; margin-left: 4px;"/> Inbox 
<input type="checkbox" class="preview-all" style="${cbxStyle}; margin-left: 4px;"/> All</span>`)
                .insertBefore(this.toolbar.findButton('.publish-changes-button').closest('.buttons-inner'));

            preview.children('input').change((e) => {
                $(e.target).closest('span').find('input').not(e.target).prop('checked', false);
                this.toolbar.findButton('.publish-changes-button').toggleClass('disabled', !$(e.target).is(':checked'));
                this.setEquality("PreviewInbox", $(e.target).closest('span').find('input.preview-inbox').is(':checked') ? true : null);
                this.setEquality("PreviewAll", $(e.target).closest('span').find('input.preview-all').is(':checked') ? true : null);
                this.refresh();
            }).end();

            this.unmatched = $(`<label class="tool-group-like"><input type="checkbox" style="${cbxStyle}"/> <i class="fa fa-question-circle-o text-orange" style="font-size: 16px"></i> Unmatched <span></span></label>`)
                .appendTo(this.toolbar.element).find('input').change(() => this.refresh()).end();
            this.stale = $(`<label class="tool-group-like"><input type="checkbox" style="${cbxStyle}"/> <i class="fa fa-circle-o-notch text-red" style="font-size: 15px"></i> Stale <span></span></label>`)
                .appendTo(this.toolbar.element).find('input').change(() => this.refresh()).end();
            this.pendingReview = $(`<label class="tool-group-like"><input type="checkbox" style="${cbxStyle}"/> <i class="fa fa-eye text-blue" style="font-size: 15px"></i> Pending Review <span></span></label>`)
                .appendTo(this.toolbar.element).find('input').change(() => this.refresh()).end();

            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        protected markupReady() {
            super.markupReady();

            this.updateCounts();
        }

        protected getButtons() {
            var buttons = super.getButtons().filter(x => x.cssClass != "add-button");

            buttons.push({
                title: 'Publish Changes',
                icon: 'fa-play-circle-o text-green',
                cssClass: 'publish-changes-button',
                disabled: true,
                separator: true,
                onClick: () => {
                    Q.confirm('Publish all changes?', () => {
                        var state = Serenity.BasicProgressDialog.startOperationProgress({
                            service: SecurityMergeService.Methods.PublishChanges,
                            noProgress: true
                        });

                        SecurityMergeService.PublishChanges({
                            OperationGuid: state.operationGuid
                        },
                            response => {
                                this.toolbar.element.find('.preview-inbox').add('.preview-all').prop('checked', false);
                                this.toolbar.findButton('publish-changes-button').addClass('disabled');
                                Q.notifySuccess("All changes are published.");
                            },
                            {
                                blockUI: false,
                                onCleanup: state.cleanup
                            }
                        );
                    });
                }
            });

            buttons.push({
                title: 'Review',
                cssClass: 'batch-review-button',
                icon: 'fa-eye text-blue',
                separator: true,
                onClick: () => {
                    var selectedIds = this.rowSelection.getSelectedAsInt64()
                        .filter(x => {
                            var item = this.view.getItemById(x);
                            return item && !item.ReviewedWhen;
                        });

                    if (!selectedIds.length) {
                        Q.notifyWarning("Please select rows to mark as reviewed!");
                        return;
                    }

                    Q.confirm(`Review selected ${selectedIds.length} rows?`, () => {
                        SecurityMergeService.BatchReview({
                            RowIds: selectedIds
                        }, response => {
                            this.rowSelection.clear();
                            this.refresh();
                        });

                    });
                }
            });

            buttons.push({
                title: 'Repair Log',
                cssClass: 'repair-log-button',
                icon: 'fa-history',
                onClick: () => {
                    new SecurityRepairLogPanel().dialogOpen();
                }
            });

            return buttons;
        }

        protected updateCounts() {
            SecurityMergeService.List({
                Take: 1,
                ColumnSelection: Serenity.ColumnSelection.KeyOnly,
                Criteria: [Serenity.Criteria.Operator.isNull, [SecurityMergeRow.Fields.SecurityId]]
            },
                response => {
                    this.unmatched && this.unmatched.find('span').text(' (' + response.TotalCount + ')');
                }, {
                blockUI: false
            }
            );

            SecurityMergeService.List({
                Take: 1,
                ColumnSelection: Serenity.ColumnSelection.KeyOnly,
                Criteria: [[SecurityMergeRow.Fields.StaleMatch], Serenity.Criteria.Operator.eq, true]
            },
                response => {
                    this.stale && this.stale.find('span').text(' (' + response.TotalCount + ')');
                }, {
                blockUI: false
            }
            );

            SecurityMergeService.List({
                Take: 1,
                ColumnSelection: Serenity.ColumnSelection.KeyOnly,
                Criteria: [Serenity.Criteria.Operator.isNull, [SecurityMergeRow.Fields.ReviewedWhen]]
            },
                response => {
                    this.pendingReview && this.pendingReview.find('span').text(' (' + response.TotalCount + ')');
                }, {
                blockUI: false
            }
            );
        }

        protected onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            var request = this.view.params as Serenity.ListRequest;

            if (this.unmatched && this.unmatched.find('input').is(':checked'))
                request.Criteria = Serenity.Criteria.and(request.Criteria,
                    [Serenity.Criteria.Operator.isNull, [SecurityMergeRow.Fields.SecurityId]]);

            if (this.stale && this.stale.find('input').is(':checked'))
                request.Criteria = Serenity.Criteria.and(request.Criteria,
                    [[SecurityMergeRow.Fields.StaleMatch], Serenity.Criteria.Operator.eq, true]);

            if (this.pendingReview && this.pendingReview.find('input').is(':checked'))
                request.Criteria = Serenity.Criteria.and(request.Criteria,
                    [Serenity.Criteria.Operator.isNull, [SecurityMergeRow.Fields.ReviewedWhen]]);

            return true;
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.frozenColumn = 7;
            return opt;
        }


        protected createSlickGrid() {
            var grid = super.createSlickGrid();
            var hidePopovers = () => {
                $('.slick-header-column.has-popover', this.element).removeClass('has-popover')['popover']('hide');
                $('.popover.bottom.in').hide();
            };
            var mergePriorityData: SecurityMergePriorityRow[];
            grid.onHeaderCellRendered.subscribe((e, args) => {

                var column = args.column as Slick.Column;
                if (securityMergeNoHint[args.column.field] || column.sortable === false || column.headerFilterType === Serenity.HeaderFilterType.disabled)
                    return;
                var i = 0;
                var content = '';
                $(args.node)['popover']({
                    trigger: 'manual',
                    html: true,
                    animation: false,
                    container: document.body,
                    placement: 'bottom',
                    content: function () {
                        return content;
                    },
                    sanitize: false,
                    title: args.column.name
                })
                    .on('mouseenter', function () {
                        content = '';
                        var _this = this;
                        hidePopovers();

                        var showPopover = () => {
                            content = formatMergePriority(mergePriorityData, args.column.field);
                            $($(_this).addClass('has-popover')['popover']('show')
                                .data("bs.popover").tip).css({
                                    'max-width': '550px',
                                    'width': '350px'
                                });
                            $('.popover').on('mouseleave', function () {
                                hidePopovers();
                            });
                        }

                        if (mergePriorityData)
                            showPopover();
                        else
                            SecurityMergePriorityService.List({
                                Sort: [SecurityMergePriorityRow.Fields.Priority]
                            },
                                response => {
                                    mergePriorityData = response.Entities || [];
                                    showPopover();
                                });
                    }).on('mouseleave', function () {
                        var _this = this;
                        setTimeout(function () {
                            if (!$('.popover:hover').length &&
                                !$('.slick-header-column.has-popover:hover').length) {
                                hidePopovers();
                            }
                        }, 300);
                    });
            });
            return grid;
        }

        protected getQuickSearchFields() {
            return [
                {
                    name: 'Name',
                    title: 'Name'
                },
                {
                    name: 'SecurityCode',
                    title: 'Security Code'
                },
                {
                    name: 'SourceSecurityId',
                    title: 'Source Security Id'
                },

                {
                    name: 'Sedol',
                    title: 'Sedol'
                },
                {
                    name: 'RIC',
                    title: 'RIC'
                },
                {
                    name: 'Isin',
                    title: 'Isin'
                },
                {
                    name: 'Cusip',
                    title: 'Cusip'
                },
                {
                    name: 'Figi',
                    title: 'Figi'
                },
                {
                    name: 'Ticker',
                    title: 'Ticker'
                },
                {
                    name: 'SecurityId',
                    title: 'Security Id'
                }
            ]
        }

        public static setupFocusToColumn(focusTo: Slick.Column, view: Slick.RemoteView<any>) {
            focusTo.headerFilterType = Serenity.HeaderFilterType.disabled;
            focusTo.format = ctx => {
                var item = ctx.item as SecurityMergeRow;
                if (!item.SecurityId)
                    return "";

                var req = view.params as Serenity.ListRequest;

                return '<a class="inline-action focus-to" title="Filter to this security ID"><i class="fa fa-crosshairs ' +
                    ((req && req.EqualityFilter && req.EqualityFilter[SecurityMergeRow.Fields.SecurityId]
                        == item.SecurityId) ? 'text-red' : 'text-purple') + '"></i></a>';
            }
        }

        protected getColumns() {
            var columns = super.getColumns();

            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));

            var focusTo = Q.tryFirst(columns, x => x.field == "FocusTo");
            focusTo && SecurityMergeGrid.setupFocusToColumn(focusTo, this.view);

            var review = Q.tryFirst(columns, x => x.field == "Review");
            if (review) {
                review.headerFilterType = Serenity.HeaderFilterType.disabled;
                review.format = ctx => {
                    var item = ctx.item as SecurityMergeRow;
                    if (item.ReviewedWhen)
                        return "";

                    return '<a class="inline-action review" title="Review"><i class="fa fa-eye text-blue"></i></a>';
                }
            }

            var clearMatch = Q.tryFirst(columns, x => x.field == "ClearMatch");
            if (clearMatch) {
                clearMatch.headerFilterType = Serenity.HeaderFilterType.disabled;
                clearMatch.format = ctx => {
                    var item = ctx.item as SecurityMergeRow;
                    if (!item.SecurityId)
                        return "";
                    return '<a class="inline-action clear-match" title="Clear Match"><i class="fa fa-unlink text-red"></i></a>';

                }
            }

            var newMatch = Q.tryFirst(columns, x => x.field == "NewMatch");
            if (newMatch) {
                newMatch.headerFilterType = Serenity.HeaderFilterType.disabled;
                newMatch.format = ctx => {
                    var item = ctx.item as SecurityMergeRow;
                    if (!item.SecurityId)
                        return "";
                    return '<a class="inline-action new-match" title="New Match"><i class="fa fa-asterisk text-yellow"></i></a>';
                }
            }

            var repairMatch = Q.tryFirst(columns, x => x.field == "RepairMatch");
            if (repairMatch) {
                repairMatch.headerFilterType = Serenity.HeaderFilterType.disabled;
                repairMatch.format = ctx => {
                    var item = ctx.item as SecurityMergeRow;
                    if (!item.SecurityId)
                        return "";
                    return '<a class="inline-action repair-match" title="Repair Match"><i class="fa fa-wrench text-purple"></i></a>';
                }
            }

            var inspect = Q.tryFirst(columns, x => x.field == "Inspect");
            if (inspect) {
                inspect.headerFilterType = Serenity.HeaderFilterType.disabled;
                inspect.format = ctx => {
                    var item = ctx.item as SecurityMergeRow;
                    if (!item.SecurityId)
                        return "";
                    return '<a class="inline-action inspect" title="Inspect"><i class="fa fa-search-plus text-blue"></i></a>';
                }
            }
            var smPrimarySecurityOverriden = Q.tryFirst(columns, x => x.field == "SMPrimarySecurityOverriden");
            if (smPrimarySecurityOverriden) {

                smPrimarySecurityOverriden.format = ctx => {
                    var item = ctx.item as SecurityMergeRow;
                    var ischecked = item.SMPrimarySecurityOverriden ? "checked" : "";
                    return '<input class="primary-security-overriden" type="checkbox" ' + ischecked + '/>';
                }
            }

            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);
            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row) as SecurityMergeRow;
            var target = $(e.target);

            if (target.parent().hasClass('inline-action'))
                target = target.parent();
            if (target.hasClass('primary-security-overriden')) {

                var ischecked = $(e.target).is(":checked");
                item.SMPrimarySecurityOverriden = ischecked;
                SecurityMergeService.EditSMPrimarySecurityOverriden({
                    RowId: item.RowId,
                    IsChecked: ischecked
                },
                    response => {
                        this.refresh();
                    });
            }
            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('focus-to')) {
                    var req = this.view.params as Serenity.ListRequest;
                    if (item.SecurityId && req && req.EqualityFilter && req.EqualityFilter[SecurityMergeRow.Fields.SecurityId] == item.SecurityId)
                        this.setEquality(SecurityMergeRow.Fields.SecurityId, null);
                    else
                        this.setEquality(SecurityMergeRow.Fields.SecurityId, item.SecurityId);
                    this.refresh();

                }
                else if (target.hasClass('review')) {
                    Q.confirm('Mark this item as reviewed?', () => {
                        SecurityMergeService.Update({
                            EntityId: item.RowId,
                            Entity: {
                                ReviewedWhen: Q.formatDate(new Date(), "yyyy-MM-ddTHH:mm:ss"),
                                ReviewedBy: Q.Authorization.username
                            }
                        }, response => this.refresh());
                    });
                }
                else if (target.hasClass('clear-match')) {
                    Q.confirm('Un-match this security?', () => {
                        SecurityMergeService.Update({
                            EntityId: item.RowId,
                            Entity: {
                                SecurityId: null
                            }
                        }, response => this.refresh());
                    });
                }
                else if (target.hasClass('new-match')) {
                    Q.confirm('Assign a new id to this security?', () => {
                        SecurityMergeService.AssignNewSecurityId({
                            RowId: item.RowId
                        },
                            response => {
                                Q.notifySuccess("Assigned Security Id: " + response.SecurityId);
                                this.refresh();
                            });
                    });
                }

                else if (target.hasClass('repair-match')) {
                    var dlg = new SecurityMergePickerDialog({
                        repairSecurityId: item.SecurityId,
                        repairSourceCode: null //todo; it seems we can't restrict this by source (we must allow two securities from the same source to be matched) item.SourceCode
                    });
                    dlg.dialogOpen();
                    dlg.onSuccess = sel => {
                        if (!sel || !sel.length || !sel[0].SecurityId) {
                            Q.notifyError("Please select an item with a Security Id!");
                            return;
                        }

                        SecurityMergeService.Update({
                            EntityId: item.RowId,
                            Entity: {
                                SecurityIdProposed: sel[0].SecurityId
                            }
                        }, response => this.refresh());
                        return true;
                    }
                }
                else if (target.hasClass('inspect')) {
                    new SecurityMergeInspectionDialog({
                        securityId: item.SecurityId
                    }).dialogOpen();
                }
            }
        }
    }

    function formatMergePriority(lines: SecurityMergePriorityRow[], field: string) {
        return `<table class="table table-striped table-sm" style="font-size: 12px">
            <thead>
                <tr>
                    <th>Priority</th>
                    <th>Source</th>
                    <th>Merge Group</th>
                </tr>
            </thead>
            <tbody>` + lines.map(x => `<tr style="${!x[field] ? 'text-decoration: line-through; color: #999;' : ''}">
                <td class="align-right">${x.Priority}</td>
                <td>${Q.htmlEncode(x.SourceCode)}</td>
                <td>${Q.htmlEncode(x.MergeGroup)}</td>
            </tr>`).join('\n') + '</tbody></table>';
    }

    export var securityMergeNoHint = {
        SecurityId: true,
        SourceCode: true,
        SourceSecurityId: true,
        RuleName: true,
        RuleNameProposed: true,
        SecurityIdProposed: true,
        SecurityIdProposedWhen: true,
        StaleMatch: true,
        RowId: true,
        Version: true,
        CreatedBy: true,
        CreatedWhen: true,
        UpdatedBy: true,
        UpdatedWhen: true,
        FocusTo: true,
        ClearMatch: true,
        NewMatch: true,
        RepairMatch: true,
        Inspect: true,
        Review: true,
        ReviewedBy: true,
        ReviewedWhen: true,
        MatchedToSourceCode: true,
        MatchedToSourceSecurityId: true,
        MatchedBy: true,
        MatchedWhen: true,
        RepairedBy: true,
        RepairedWhen: true
    }
}